import { Flex } from "@chakra-ui/react";
import ContentRightItem from "./ContentRightItem";
import { ContaItemResponse } from "core/features/conta/typings";
import StatusContentRight from "./StatusContentRight";
import moment from "moment";

interface ContentRightProps {
  item: ContaItemResponse;
}

export default function ContentRight({ item }: ContentRightProps) {
  return (
    <Flex flexDir="column" w="100%" pr={4}>
      <StatusContentRight item={item} />
      {item.multa ? (
        <ContentRightItem titulo="Multa" valor={item.multa} />
      ) : null}
      {item.juros ? (
        <ContentRightItem titulo="Juros" valor={item.juros} />
      ) : null}
      {item.taxaCobranca ? (
        <ContentRightItem titulo="Tx. Cobrança" valor={item.taxaCobranca} />
      ) : null}
      {item.desconto ? (
        <ContentRightItem
          titulo={`Desconto ${
            item.descontoValidoAte
              ? `(Até ${moment(item.descontoValidoAte).format("DD/MM/YYYY")})`
              : ""
          }`}
          valor={item.desconto}
        />
      ) : null}
      {item.outrasTaxas ? (
        <ContentRightItem titulo="Outras Taxas" valor={item.outrasTaxas} />
      ) : null}
      {item.valorCorrecaoMonetaria ? (
        <ContentRightItem titulo="Correção Monetária" valor={item.valorCorrecaoMonetaria} />
      ) : null}
      {item.valorLiquido ? (
        <ContentRightItem titulo="Total Líquido" valor={item.valorLiquido} />
      ) : null}
    </Flex>
  );
}
